<script setup>
import { storeToRefs } from 'pinia';
import { useEventStore } from '../stores/event-store';

/**
 * Props
 * Event url
 */
const props = defineProps({
  eventUrl: {
    type: String,
    required: true,
  },
});

/**
 * Get event
 */
const { getByUrl: getEventByUrl } = useEventStore();

/**
 * Event
 */
const { event } = storeToRefs(useEventStore());

/**
 * Get event by url
 */
getEventByUrl(props.eventUrl);
</script>

<template>
  <div class="container-fluid" style="height: calc(100vh - 60px)">
    <div class="row">
      <div
        id="offcanvasResponsive"
        class="offcanvas-lg offcanvas-start col-lg-2 d-flex flex-grow-1 position-fixed bottom-0 sidebar"
        tabindex="-1"
        aria-labelledby="offcanvasResponsiveLabel"
      >
        <div class="offcanvas-header">
          <h5 id="offcanvasResponsiveLabel" class="offcanvas-title">Menu</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            data-bs-target="#offcanvasResponsive"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body d-flex flex-grow-1">
          <div class="d-flex flex-column flex-grow-1 p-3">
            <ul class="nav nav-pills flex-column mb-auto pt-4">
              <li class="nav-item">
                <RouterLink
                  :to="{
                    name: 'event.manage.detail',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-calendar me-2"></i>
                    Event
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.setting.edit',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{ active: $route.path.includes('/manage/settings') }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-cog me-2"></i>
                    Settings
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.team.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{
                    active: $route.path.includes('/manage/teams/'),
                  }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-users-class me-2"></i>
                    Teams
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.angler.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{ active: $route.path.includes('/manage/anglers/') }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-users me-2"></i>
                    Anglers
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.sector.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{ active: $route.path.includes('/manage/sectors/') }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-map-marker-alt me-2"></i>
                    Sectors
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.group.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{ active: $route.path.includes('/manage/groups/') }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-layer-group me-2"></i>
                    Groups
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.session.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{ active: $route.path.includes('/manage/sessions/') }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-watch me-2"></i>
                    Sessions
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.registration.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{
                    active: $route.path.includes('/manage/registration/'),
                  }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-user-plus me-2"></i>
                    Registration
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.rotation.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{
                    active: $route.path.includes('/manage/rotations/'),
                  }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-route me-2"></i>
                    Rotation
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.draw.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{ active: $route.path.includes('/manage/draws/') }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-table me-2"></i>
                    Draw
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.score.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{ active: $route.path.includes('/manage/scores/') }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-edit me-2"></i>
                    Scores
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.result.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{ active: $route.path.includes('/manage/results/') }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-file-alt me-2"></i>
                    Results
                  </div>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  :to="{
                    name: 'event.manage.security.list',
                    params: { eventUrl: eventUrl },
                  }"
                  class="nav-link"
                  :class="{
                    active: $route.path.includes('/manage/securities/'),
                  }"
                >
                  <div
                    data-bs-dismiss="offcanvas"
                    data-bs-target="#offcanvasResponsive"
                  >
                    <i class="fas fa-shield-check me-2"></i>
                    Security
                  </div>
                </RouterLink>
              </li>
            </ul>
            <hr />
            <!-- <div class="dropdown">
              <a
                href="#"
                class="d-flex align-items-center text-decoration-none dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src="https://github.com/mdo.png"
                  alt=""
                  class="rounded-circle me-2"
                  width="32"
                  height="32"
                />
                <strong>mdo</strong>
              </a>
              <ul class="dropdown-menu dropdown-menu-dark text-small shadow">
                <li><a class="dropdown-item" href="#">New project...</a></li>
                <li><a class="dropdown-item" href="#">Settings</a></li>
                <li><a class="dropdown-item" href="#">Profile</a></li>
                <li><hr class="dropdown-divider" /></li>
                <li><a class="dropdown-item" href="#">Sign out</a></li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>

      <main class="ms-lg-auto col-lg-10 px-md-4">
        <RouterView />
      </main>
    </div>
  </div>
</template>
